// import { Button } from '@mui/material'
import styled from 'styled-components'
import { colors } from '../../styles/Variables'

export const HeaderContainerDesktop = styled.div`
    height: 300px;
    background-image: url(${props => props.backgroundImage}); 
    background-position: bottom;
    background-color: ${props => props.backgroundColor || '#ffffff'};
    background-size: cover;
    display: flex;
    padding-left: 180px;
    align-items: center;
    color: ${colors.white};
    
    @media (max-width: 1366px) {
        padding-left: 0px;
    }
    @media (max-width: 768px) {
        justify-content: center;
        flex-direction: column;
        height: 100vw;
        padding: 0px;
        gap: 5vw;
        margin-bottom: 1.5rem;
    }
`
export const LogoWrapperBorder = styled.div`
    width: 140px;
    height: 140px;
    border-radius: 50%;
    margin: 2rem;
    border: 2px solid ${colors.white};
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
        width: 100px;
        height: 100px;
        margin: 0;
        padding: 6px;
        border: 4px solid ${colors.white};
    }
`;

export const LogoWrapper = styled.div`
    width: 139px;
    height: 139px;
    border-radius: 50%;
    border: 2px solid ${colors.white};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white; 

    @media (max-width: 768px) {
        width: 100%;
        height: 94px;
    }
`;

export const Logo = styled.img`
    max-width: 90%;
    max-height: 80%;
    border-radius: 20%;
    object-fit: contain;

    @media (max-width: 768px) {
        width: 100%;
        height: 60%;
    }
`;


export const LogoFallback = styled.div`
    width: 140px;
    box-sizing: border-box; 
    height: 140px;
    border-radius: 50%;
    margin: 2rem;
    border: 2px solid ${colors.white};
    padding: 5px;
    display: flex; 
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    /* @media (max-width: 768px) {
        width: 25vw;
        height: 25vw;
        max-width: 120px;
        max-height: 120px;
        margin: 0vw 5vw;
    } */
`;

export const H3 = styled.h4`
    width: 525px;
    text-align: justify;
    @media (max-width: 768px) {
        display: none;
    }
`
export const TitleDesktop = styled.h1`
    @media (max-width: 768px) {
        display: none;
    }
`
export const TitleMobile = styled.h1`
    display: none;
    text-align: center;
    @media (max-width: 768px) {
        display: block;
        margin-top: 10vw;
    }
`

export const FiltersMobile = styled.div`
    display: none;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`

// Estilos Cashback

export const CashbackContainer = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 500px;

    @media (max-width: 768px) {
        align-items: center;
        text-align: center;
    }
`;

export const CashbackInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`;

export const CashbackText = styled.p`
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: bold;
    margin: 0;
`;

export const MoreInfoLink = styled.a`
    font-size: 0.85rem;
    color: #FFFFFF;
    text-decoration: underline;
    cursor: pointer;
`;

export const ActivateButton = styled.button`
    background: transparent;
    color: white;
    border: none;
    padding: 0.6rem 2rem;
    border-radius: 8px;
    border: 1px solid #ffffff;
    cursor: pointer;
    margin-top: 10px;
    text-transform: uppercase;

    &:hover {
        background: #ffffff;
        color: #4FA9E4;
    }
`;